define('Components/AboutCornerWidget/js/views/AboutCornerMapWidgetInstanceView',[
    'jquery',
    'underscore',
    'WidgetInstanceView',
    'app',
    'mapboxGL',
    'template!Components/AboutCornerWidget/templates/map',
    'template!blocks/stores/store-locator-infowindowint',
    'InternalLinkView',
    'router'
],
function($,_, WidgetInstanceView, app, mapboxGL, template, storeLocatorInfowindowTemplate, InternalLinkView, router){
    var mapboxGL, turf, Map, LngLat, LngLatBounds, Marker, Popup, NavigationControl, mapPopup;
    var map;

    function InitMapboxGL(callback,err){
        mapboxGL.init(function(mapboxGLJS,turfJS){
            turf = turfJS;
            Map = mapboxGLJS.Map;
            LngLat = mapboxGLJS.LngLat;
            LngLatBounds = mapboxGLJS.LngLatBounds;
            Marker = mapboxGLJS.Marker;
            Popup = mapboxGLJS.Popup;
            NavigationControl = mapboxGLJS.NavigationControl;
            callback();
        },err);
    }

    return WidgetInstanceView.extend({
        name: 'AboutCornerMapWidgetInstanceView',
        events: {
        },

        afterRender:function(){
            var view = this;

            this.model.getCornersGeoJson()

            InitMapboxGL(function(){
                view.renderMap();
            });
        },

        renderMap: function() {
            var view = this,
                mapEl = view.$('.map')[0],
                mapStyle = app.c('_MAPBOX_STYLES_URL_', 'mapbox://styles/mapbox/streets-v9');

            if (!mapEl) { return }

            var bounds = _.map(
                (
                    // west, south, east, north
                    view.model.p('bounding_box')
                    || '-4.5703, 41.836, 9.40429, 50.90303'
                ).split(','),function(p){
                return parseFloat(p) || 0;
            })

            map = new Map({
                maxZoom: 16,
                scrollZoom: false,
                gestureHandling: "cooperative",
                container: mapEl,
                style: mapStyle,
                bounds: bounds,
                fitBoundsOptions: {
                    padding: {
                        top: 20,
                        bottom: 20,
                        left: 20,
                        right: 20,
                    }
                },
                dragPan: !app.isMobile(),
            });
            map.addControl(new NavigationControl());

            map.on('load', function () {
                view.createMarkers()
                mapPopup = new Popup({offset:[0,-50],anchor:'bottom'});
            })
        },

        createMarkers: function() {
            var view = this,
                iconSize = app.isMobile() ? 0.7 : 0.9;

            map.addSource('shops', {
                type: 'geojson',
                data: this.model.getCornersGeoJson(),
            })

            map.loadImage(
                UrlFactory.getThemeUrl()+'medias/img/marker-logo-corner.png',
                function (error, image) {
                    if (error) throw error;
                    map.addImage('corner', image);

                    map.addLayer({
                        id: 'corner',
                        type: 'symbol',
                        source: 'shops',
                        layout: {
                            'icon-image': 'corner',
                            'icon-anchor': 'bottom',
                            'icon-allow-overlap': true,
                            'icon-size': iconSize,
                        },
                    });
                }
            )

            map.on('click', 'corner', view.clickOnMarker)
        },

        clickOnMarker: function(e) {
            var feature = e.features[0],
                properties = feature.properties,
                id_store = properties.id_store,
                coordinates = feature.geometry.coordinates.slice(),
                store = app.getStore(id_store),
                html = storeLocatorInfowindowTemplate({store: store});

            // force close previous popup
            if (mapPopup) { mapPopup.remove() }
            setTimeout(function() {
                mapPopup
                    .setLngLat(coordinates)
                    .setHTML(html)
                    .addTo(map);
            })
        },

        getTemplate: function () {
            return template;
        },
    })
});
